export default __webpack_public_path__ + "static/media/move_container_to_load.4b13a466.svg";